export { handleRestoreSelected } from '~teacher/components/quizzes/QuizTrashActions/handleRestoreSelected';
